import { Button } from "primereact/button";
import { EnvironmentDropdown } from "./EnvironmentDropdown";

/**
 * Main header component
 */
export const Header = (props: { onClick?: () => void }) => {
    return (
        <header
            style={{ 
                paddingTop: 24, 
                paddingBottom: 24,
                boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
                position: 'sticky',
                top: 0,
                zIndex: 100,
            }}
            className={`w-full`}
        >
            <div className="mx-6 flex justify-content-between align-items-center">
                <div className="flex align-items-center">
                    <img 
                        height={40} 
                        src={"https://www.idwalmarine.com/hubfs/Training/images/idwal-logo-reversed.svg"} 
                        alt="Idwal Logo" 
                        style={{ 
                            filter: 'drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1))',
                            transition: 'all 0.3s ease'
                        }}
                        className="hover:rotate-2"
                    />
                    <h2 className="ml-3 text-xl font-medium text-primary hidden md:block" style={{ color: 'var(--primary-color)' }}>
                        Developer Dashboard
                    </h2>
                </div>
                <div className={`flex align-items-center`}>
                    <EnvironmentDropdown />
                    <Button
                        data-testid="header-burgermenu-icon"
                        className="p-button-rounded p-button-text"
                        icon="pi pi-bars"
                        onClick={props.onClick}
                        style={{ 
                            backgroundColor: 'var(--primary-light)',
                            color: 'white',
                            width: '42px',
                            height: '42px',
                            transition: 'all 0.3s ease'
                        }}
                    ></Button>
                </div>
            </div>
        </header>
    );
};